import { render } from "./CardScroll.vue?vue&type=template&id=0166da46"
import script from "./CardScroll.vue?vue&type=script&lang=ts"
export * from "./CardScroll.vue?vue&type=script&lang=ts"
script.render = render

export default script